import * as actionTypes from './actionTypes';

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case actionTypes.LOAD_GRID.REQUEST:
      return { ...state, loading: true };
    case actionTypes.LOAD_GRID.SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
        loadingError: false
      };
    case actionTypes.LOAD_GRID.FAILURE:
      return {
        ...state,
        ...payload,
        loading: false,
        loadingError: true
      };
    case actionTypes.CHANGE_SAVED_VIEW:
      return {
        ...state,
        columnState: payload.columnState,
        columnsWithoutActions: payload.columnsWithoutActions,
        data: payload.data,
        sortState: payload.sortState,
        filterState: payload.filterState,
        savedViewState: payload.savedViewState || state.savedViewState,
        unAppliedFilterState: payload.unAppliedFilterState,
        totalRows: payload?.totalRows
      };
    case actionTypes.CLEAR_FILTER:
      return {
        ...state,
        unAppliedFilterState: [...state.unAppliedFilterState].filter(
          (filter) => filter.field !== payload.name
        )
      };
    case actionTypes.LOAD_MORE.REQUEST:
      return {
        ...state,
        isPaginating: true
      };
    case actionTypes.LOAD_MORE.SUCCESS:
      return {
        ...state,
        isPaginating: false,
        page: payload.page,
        data: payload.data
      };
    case actionTypes.LOAD_MORE.FAILURE:
      return {
        ...state,
        isPaginating: false
      };
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        unAppliedFilterState: state.filterState
      };
    case actionTypes.SAVE_FILTER:
      return {
        ...state,
        filterState: payload.filterState,
        data: payload.data,
        totalRows: payload?.totalRows,
        drawerOpen: false,
        previousState: {
          ...state,
          filterState: payload.filterState,
          data: payload.data,
          totalRows: payload?.totalRows
        }
      };
    case actionTypes.UPDATE_UNAPPLIED_FILTERS:
      return {
        ...state,
        unAppliedFilterState: [
          ...state.unAppliedFilterState.filter((filter) => filter.field !== payload.name),
          // NOTE: if value is an array (like in the case of multiselect) then add multiple filters
          ...(Array.isArray(payload.value) ? payload.value : [payload.value])
        ]
      };
    case actionTypes.SAVE_COLUMN:
      return {
        ...state,
        columnState: payload.columnState,
        columnsWithoutActions: payload.columnState,
        drawerOpen: false,
        previousState: {
          ...state,
          columnState: payload.columnState,
          columnsWithoutActions: payload.columnState
        }
      };
    case actionTypes.SAVE_SORT:
      return {
        ...state,
        sortState: payload.sortState,
        data: payload.data,
        drawerOpen: false,
        previousState: {
          ...state,
          sortState: payload.sortState,
          data: payload.data
        }
      };
    case actionTypes.ADD_USER_VIEW:
      return {
        ...state,
        savedViewState: {
          active: payload?.activeView || state.savedViewState.active,
          views: payload.views
        }
      };
    default:
      // If a setGrid/dispatch does not match one of the above types
      // then spread new values into state
      return { ...state, ...(action || {}) };
  }
};

export default reducer;
